import { Injectable , inject} from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { User, UserAgreement } from './user';

export type UserRequest = Omit<User, 'isSystemAdmin' | 'identifier'>;

export interface CarrierPortalUserRequest {
	emailAddress: string;
}

@Injectable({
	providedIn: 'root'
})
export class UsersService {
	private http = inject(HttpClient);




	getUsers(customerCode: string): Observable<User[]> {
		const getUsersUrl = `api/customers/users?customerCode=${customerCode}&api-version=1.0`;
		return this.http.get<User[]>(getUsersUrl);
	}

	createUser(user: UserRequest): Observable<User> {
		const createUserUrl = 'api/customers/users?api-version=1.0';
		return this.http.post<User>(createUserUrl, user);
	}

	updateUser(userIdentifier: string, updatedUser: Partial<User>): Observable<User> {
		const updateUserUrl = `api/customers/users/${userIdentifier}?api-version=1.0`;
		return this.http.patch<User>(updateUserUrl, updatedUser);
	}

	addCarrierPortalUser(customerCode: string, divisionIdentifier: string, carrierAccountIdentifier: string, request: CarrierPortalUserRequest): Observable<User> {
		const addCarrierPortalUserUrl = `api/customers/customers/${customerCode}/divisions/${divisionIdentifier}/carrieraccounts/${carrierAccountIdentifier}/carrierPortalUsers?api-version=1.0`;
		return this.http.post<User>(addCarrierPortalUserUrl, request);
	}

	deleteCarrierPortalUser(customerCode: string, divisionIdentifier: string, carrierAccountIdentifier: string, emailAddress: string): Observable<User> {
		const deleteCarrierPortalUserUrl = `api/customers/customers/${customerCode}/divisions/${divisionIdentifier}/carrieraccounts/${carrierAccountIdentifier}/carrierPortalUsers/${emailAddress}?api-version=1.0`;
		return this.http.delete<User>(deleteCarrierPortalUserUrl);
	}

	addUserAgreement(userAgreement: UserAgreement): Observable<User> {
		return this.http.post<User>(`api/customers/users/me/agreements?api-version=1.0`, userAgreement);
	}
}


